

















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { db } from "@/scripts/firebase";
import { collectionName } from "../../services/collection-name";
import {
  JinroGameHistorySummaryDocument,
  JinroRoomDocument,
} from "../../services/datatypes";
import ListGameHistorySummaries from "@/components/shared/ListGameHistorySummaries.vue";

@Component({
  components: {
    ListGameHistorySummaries,
  },
})
export default class RoomGameHistorySummaries extends Vue {
  detacher?: firebase.Unsubscribe;
  gameHistorySummaries: Array<JinroGameHistorySummaryDocument> | null = null;

  created() {
    this.detacher = this.refCollection.onSnapshot((snapshot) => {
      const jinroRoom = snapshot.data() as JinroRoomDocument;
      this.gameHistorySummaries = jinroRoom.jinroGameHistorySummaries
        ? (jinroRoom.jinroGameHistorySummaries as Array<
            JinroGameHistorySummaryDocument
          >)
        : [];

      this.$emit(
        "room-game-histories-length",
        this.gameHistorySummaries.length
      );
    });
  }

  destroyed() {
    this.detacher && this.detacher();
  }
  get owner(): string {
    if (!this.$store.state.jinroRoom) {
      return "";
    }
    return this.$store.state.jinroRoom.owner;
  }

  get refCollection(): firebase.firestore.DocumentReference {
    return db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId);
  }
}
